<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-align: center; margin-top: 230px;"><strong><em>A Shallow Lad’s Tale of the 70s</em></strong></p>
<p><strong><em><br/>
</em></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?0f5819c6